var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop1 = function SvgTop1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "m18.843-.166 1.73 5.2L33.79 27.948l5.083-2.703L27.201 1.51l-2.274-4.5-6.084 2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B00",
    d: "m12.556-1.014 5.153-2.74 15.413 28.988-5.153 2.74L12.556-1.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "M41.783-1.366 36.7-4.069 21.218 25.05l5.084 2.703L39.434 5l2.35-6.366Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F00000",
    d: "m42.205-3.62 5.153 2.74-15.335 28.84-5.153-2.74L42.205-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D769",
    d: "m30.016 13.497-.836 15.27.836 14.937c8.367 0 15.172-6.776 15.172-15.107-.008-8.324-6.813-15.1-15.172-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D769",
    d: "M14.844 28.597c0 8.331 6.804 15.107 15.172 15.107V13.497c-8.368 0-15.172 6.776-15.172 15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB32",
    d: "m30.016 15.831-.836 12.937.836 12.603c7.07 0 12.828-5.726 12.828-12.774-.008-7.04-5.758-12.766-12.828-12.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB32",
    d: "M17.188 28.597c0 7.048 5.75 12.774 12.828 12.774V15.83c-7.078 0-12.828 5.726-12.828 12.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.898 33.568h3.118v-9.14H26.39v-1.774c1.453-.273 2.453-.646 3.375-1.214h2.14v12.128h2.727v2.326h-8.735v-2.326Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v44H0z"
  })))));
};
export default SvgTop1;